export const EXCEL_VIEW_NON_DRAGGABLE_COLUMNS = [
  "Batch ID",
  "Batch Date",
  "Comments",
];
